import { render, staticRenderFns } from "./ColorManipulation.vue?vue&type=template&id=53c03768&scoped=true"
import script from "./ColorManipulation.vue?vue&type=script&lang=js"
export * from "./ColorManipulation.vue?vue&type=script&lang=js"
import style0 from "./ColorManipulation.vue?vue&type=style&index=0&id=53c03768&prod&scoped=true&lang=scss"
import style1 from "./ColorManipulation.vue?vue&type=style&index=1&id=53c03768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c03768",
  null
  
)

export default component.exports